import {
  Box,
  Button,
  InputBase,
  TableCell,
  TableRow,
  Typography,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CustomTable from "../../components/common-components/CustomTable";
import {
  AddIcon,
  ArrowRightCircleIcon,
  DeleteIconTable,
} from "../../assets/Icon/ArrowIcon";
import SearchIcon from "@mui/icons-material/Search";
import AccountStatusButton from "../../components/common-components/AccountStatusButton";

import NoDataFound from "../../components/common-components/NoDataFound";

import { useAppDispatch } from "../../stores/store";
import { useSelector } from "react-redux";

import CommonPagination from "../../components/common-components/CommonPagination";
import AddUserModal from "./AddClient";
import DeleteModal from "./DeleteClient";
import { getClientList } from "../../stores/clients";
import moment from "moment";
import AddClientModal from "./AddClient";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import { useLocation, useNavigate } from "react-router-dom";
import NoOrdersFound from "../../components/common-components/NoOrdersFound";
import { CrossIcon } from "../../assets/Icon/ModalIcon";
import {
  CloseButton,
  CloseButtonWrapper,
} from "../../components/style/modalStyleLarge";

const Client = () => {
  const dispatch = useAppDispatch();
  const {
    data: agentList,
    status,
    error,
    total_records,
  } = useSelector((state: any) => state.clients);
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const [page, setPage] = useState(state?.pageNo ? state?.pageNo : 1);
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState<any>("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState<string>("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  useEffect(() => {
    fetchAgents();
  }, [page, limit, debouncedSearch]);

  const fetchAgents = async () => {
    try {
      setLoading(true);

      // Debounce delay
      await new Promise((resolve) => setTimeout(resolve, 200));

      const offset = (page - 1) * limit;

      await dispatch<any>(
        getClientList({
          offset,
          limit,
          search: searchQuery.trim(),
        }),
      );
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  // const fetchAgents = () => {
  //   const offset = (page - 1) * limit;

  //   dispatch(
  //     getClientList({
  //       offset,
  //       limit,
  //       search: searchQuery,
  //     })
  //   );
  // };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setPage(1);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    setCurrentPage(newPage);
  };
  const handleOpen = () => setOpenModal(true);

  const handleClose = () => {
    setOpenModal(false);
    setSelectedId(null);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setSelectedId(null);
  };

  const handleOpenDeleteModal = (agentId: number) => {
    setSelectedId(agentId);
    setOpenDeleteModal(true);
  };

  const formatToTimeZone = (
    dateInput: string | Date,
    timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: string = "en-US",
    options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "2-digit",
    },
  ): string => {
    if (!dateInput) return "Invalid Date";

    const date = new Date(
      typeof dateInput === "string" && !dateInput.endsWith("Z")
        ? dateInput + "Z"
        : dateInput,
    );

    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    return new Intl.DateTimeFormat(locale, {
      timeZone,
      ...options,
    }).format(date);
  };

  return (
    <StyledBox sx={{ paddingY: "16px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          padding: "20px",
          "@media (min-width: 600px)": {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          },
        }}
      >
        <Title>Client Listings</Title>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            "@media (min-width: 600px)": {
              flexDirection: "row",
              alignItems: "center",
            },
          }}
        >
          <SearchWrapper>
            <SearchIcon />
            <StyledInputBase
              placeholder="Search here..."
              inputProps={{ "aria-label": "search" }}
              value={searchQuery}
              onChange={handleSearchChange}
            />
            {searchQuery && (
              <CloseButtonWrapper>
                <CloseButton
                  onClick={() => {
                    setSearchQuery("");
                  }}
                  sx={{
                    cursor: "pointer",
                    display: "inline-flex",
                    color: "red",
                    position: "absolute",
                    right: "1px",
                    top: "6.5px",
                  }}
                >
                  <CrossIcon />
                </CloseButton>
              </CloseButtonWrapper>
            )}
          </SearchWrapper>

          <StyledButton
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleOpen}
          >
            Add Client
          </StyledButton>
        </Box>
      </Box>

      <CustomTable
        headings={[
          "Sr. No",
          "First Name",
          "Last Name",
          "Email",
          "Created",
          "Status",
          " ",
        ]}
      >
        <>
          {loading && (
            <TableRow>
              <TableCell
                colSpan={7}
                sx={{
                  padding: "16px 24px",
                }}
              >
                <ListLoadingNew />
              </TableCell>
            </TableRow>
          )}

          {!loading && agentList?.length === 0 && (
            <TableRow>
              <TableCell colSpan={7}>
                <NoOrdersFound
                  title="No Clients Found"
                  breakWords={["your"]}
                  subTitle="Try adding new client or modifying your search criteria."
                />
              </TableCell>
            </TableRow>
          )}
          {!loading &&
            agentList?.length > 0 &&
            agentList?.map((item: any, index: number) => (
              <TableRow>
                <TableCell
                  sx={{
                    padding: "16px 24px",
                  }}
                >
                  <Typography>{(page - 1) * limit + index + 1}</Typography>
                </TableCell>
                <TableCell
                  sx={{
                    padding: "16px 24px",
                  }}
                >
                  <Typography>{item?.first_name || "-"}</Typography>
                </TableCell>

                <TableCell
                  sx={{
                    padding: "16px 24px",

                    whiteSpace: "nowrap",
                  }}
                >
                  <Typography>{item?.last_name || "-"}</Typography>
                </TableCell>
                <TableCell
                  sx={{
                    padding: "16px 24px",

                    whiteSpace: "nowrap",
                  }}
                >
                  <Typography>{item?.email || "-"}</Typography>
                </TableCell>
                <TableCell
                  sx={{
                    padding: "16px 24px",

                    whiteSpace: "nowrap",
                  }}
                >
                  {item?.created_at ? formatToTimeZone(item.created_at) : "-"}
                </TableCell>

                <TableCell
                  sx={{
                    padding: "16px 24px",
                  }}
                >
                  <AccountStatusButton
                    rowstatus={item?.is_active ?? false}
                    agentId={item?.id ?? 0}
                  />
                </TableCell>

                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    {item?.id && (
                      <>
                        <Box
                          onClick={() => handleOpenDeleteModal(item.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <DeleteIconTable />
                        </Box>
                        <Box
                          onClick={() =>
                            navigate(`/admin-clients/${item?.id}`, {
                              state: { pageNo: page },
                            })
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <ArrowRightCircleIcon />
                        </Box>
                      </>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
        </>
      </CustomTable>

      {/* Pagination */}
      {Math.ceil(total_records / limit) > 1 && (
        <Box sx={{ display: "flex", justifyContent: "end", mt: 3 }}>
          <CommonPagination
            currentPage={page}
            totalPages={Math.ceil(total_records / limit)}
            onPageChange={handlePageChange}
          />
        </Box>
      )}

      <AddClientModal
        open={openModal}
        handleClose={handleClose}
        agentId={selectedId}
        onSuccess={fetchAgents}
      />

      <DeleteModal
        open={openDeleteModal}
        handleClose={handleCloseDeleteModal}
        id={selectedId}
        onSuccess={fetchAgents}
      />
    </StyledBox>
  );
};

export default Client;

const StyledBox = styled(Box)({
  background: "#ffffff",
  boxShadow: "0px 2px 40px 0px #DDE3EA33",
  borderRadius: "10px",
});

const Container = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "20px",
});

const Title = styled(Typography)({
  color: "#01060B !important",
  fontSize: "20px !important",
  fontWeight: "600 !important",
});

const SearchContainer = styled(Box)({
  display: "flex",
  gap: "10px",
  alignItems: "center",
});

const SearchWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  background: "#F6F9FD",
  color: "#6B6B6B",
  borderRadius: "8px",
  padding: "5px 10px",
  position: "relative",
  "&:hover": {
    background: "#F6F9FD",
  },
});

const StyledButton = styled(Button)({
  width: "120px !important",
  whiteSpace: "nowrap",
  borderRadius: "6px !important",
  height: "40px !important",
});

const StyledInputBase = styled(InputBase)({
  minWidth: "300px",
  padding: "3px",
});
